<template>
    <div class="modal fade" id="add_update_branch_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="add_update_branch_modalLabel">Add / Update Vendor Of Warehouse: {{resName}}</h4>
                </div>
                <form method="post" enctype="multipart/form-data" @submit.prevent="addUpdateBranch()">
                    <div class="modal-body">
                        <!--<div class="form-group">-->
                            <!--<label>Restaurant</label>-->
                            <!--<select readonly="readonly" v-model="branch.restaurantsByRestaurantId.id" class="form-control">-->
                                <!--<option value="">Select Restaurant</option>-->
                                <!--<option v-for="restaurant in restaurants" v-bind:key="restaurant.id" v-bind:value="restaurant.id">{{restaurant.name}}</option>-->
                            <!--</select>-->
                        <!--</div>-->
                        <CitiesAndAreas ref="cityAndAreaComp"/>
                        <BranchMenuComponent v-if="branch.id !== 0"
                            :branch-id="branch.id"
                            :branch-name="branch.areasByAreaId.name"
                            ref="BranchMenuComponent"/>
                        <div class="form-group row">
                          <div class="col-md-6">
                            <label>Name</label>
                            <input :disabled="readOnly" v-model="branch.contactName1" type="text" class="form-control" placeholder="Name...">
                          </div>
                          <div class="col-md-6">
                            <label>Phone 1</label>
                            <input :disabled="readOnly" v-model="branch.phone1" type="text" class="form-control" placeholder="Number...">
                          </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-md-6">
                            <label>Name</label>
                            <input :disabled="readOnly" v-model="branch.contactName2" type="text" class="form-control" placeholder="Name...">
                          </div>
                          <div class="col-md-6">
                            <label>Phone 2</label>
                            <input :disabled="readOnly" v-model="branch.phone2" type="text" class="form-control" placeholder="Number...">
                          </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-md-6">
                            <label>Name</label>
                            <input :disabled="readOnly" v-model="branch.contactName3" type="text" class="form-control" placeholder="Name...">
                          </div>
                          <div class="col-md-6">
                            <label>Phone 3</label>
                            <input :disabled="readOnly" v-model="branch.phone3" type="text" class="form-control"  placeholder="Number...">
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Delivery Radius</label>
                          <input :disabled="readOnly" v-model="branch.deliveryRadius" type="number" class="form-control" placeholder="Delivery Radius..." min="0">
                        </div>

                        <div class="form-group">
                          <label>Minimum Order Price</label>
                          <input :disabled="readOnly || isBranchUser" v-model="branch.minimumOrder" type="number" class="form-control" required="required" placeholder="Minimum Order Price..." min="0">
                        </div>

                        <div class="form-group">
                          <label>Tax Amount Charged</label>
                          <input :disabled="readOnly" v-model="branch.tax" type="number" step="any"  class="form-control" required="required" placeholder="Tax..." min="0">
                        </div>

                        <div class="form-group">
                          <label>Tax On Card</label>
                          <input :disabled="readOnly" v-model="branch.cardTax" type="number" step="any"  class="form-control" required="required" placeholder="Tax..." min="0">
                        </div>

                        <div v-if="(userRole === 'ADMIN')">
                          <div class="form-group">
                            <label>Facebook</label>
                            <input :disabled="isBranchUser" v-model="mediaLinks.facebook" type="url"  class="form-control" placeholder="Facebook link...">
                          </div>

                          <div class="form-group">
                            <label>Instagram</label>
                            <input :disabled="isBranchUser" v-model="mediaLinks.instagram" type="url"  class="form-control" placeholder="Instagram link...">
                          </div>

                          <div class="form-group">
                            <label>Twitter</label>
                            <input :disabled="isBranchUser" v-model="mediaLinks.twitter" type="url"  class="form-control" placeholder="Twitter link...">
                          </div>

                          <div class="form-group">
                            <label>YouTube</label>
                            <input :disabled="isBranchUser" v-model="mediaLinks.youtube" type="url"  class="form-control" placeholder="Youtube link...">
                          </div>
                        </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="checkbox">
                            <label>
                              <input :disabled="readOnly || isBranchUser" v-model="branch.disableTimingsForPortal" type="checkbox">
                              Disable Vendor Timings For Portal
                            </label>
                          </div>
                          <div class="checkbox">
                            <label>
                              <input :disabled="readOnly || isBranchUser" v-model="branch.open24Hours" type="checkbox"> is 24 Hrs Open
                            </label>
                          </div>
                          <div class="checkbox">
                            <label>
                              <input :disabled="readOnly" v-model="branch.freeDelivery" type="checkbox"> is Free Delivery
                            </label>
                          </div>
                          <div class="checkbox">
                            <label>
                              <input :readonly="readOnly" :disabled="isBranchUser" v-model="branch.isPortalEnabled" type="checkbox"> Portal Enabled
                            </label>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="checkbox">
                            <label>
                              <input :disabled="readOnly" v-model="branch.deliveryEnabled" type="checkbox" > is Delivery Enable
                            </label>
                          </div>
                          <div class="checkbox">
                            <label>
                              <input :disabled="readOnly" v-model="branch.pickupEnabled" type="checkbox" > is Pickup Enable
                            </label>
                          </div>
                          <div class="checkbox" v-if="userRole!=='USER'">
                            <label>
                              <input :disabled="readOnly || isBranchUser" v-model="branch.masterBranch" type="checkbox"> is Master Vendor
                            </label>
                          </div>
                          <div class="checkbox" v-if="userRole === 'ADMIN'">
                            <label>
                              <input @click="branch.isEnable = !branch.isEnable" :checked="!branch.isEnable" type="checkbox"> Disable Vendor on Bebambi App
                            </label>
                          </div>
                        </div>
                      </div>
                      <cost-based-configuration
                          ref="costBasedDeliveryConfiguration"
                          :cost-based-delivery-config="branch.costBasedDeliveryConfig"
                          :distance-based-delivery-config="branch.deliveryConfigurations"
                          :based-on-distance=false
                      />
                      <cost-based-configuration
                          ref="distanceBasedDeliveryConfiguration"
                          :cost-based-delivery-config="branch.costBasedDeliveryConfig"
                          :distance-based-delivery-config="branch.deliveryConfigurations"
                          :based-on-distance=true
                      />

                        <TimingsComponent
                            ref="TimingsConfiguration"
                            :label="'Vendor Timings'"
                            :is-deal="false"
                            :update-timing-configuration="branch.timings"
                        />
                        <div class="form-group" v-if="userRole=== 'ADMIN'">
                            <div v-if="couponAlreadyApplied === false">
                              <label>Apply Discount
                                <button type="button" v-on:click="addAddNewCoupon()" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></button>
                              </label>
                              <multiselect id="filter1"
                                           v-model="branch.couponById"
                                           :options="resCoupon"
                                           label="couponCode"
                                           track-by="couponCode"
                                           placeholder="Select Coupon"
                                           @close="resetFlags"
                              ></multiselect>
                            </div>
                            <div v-else-if="couponAlreadyApplied === true">
                                <label>Selected Discount</label>
                                <div class="row">
                                  <div class="col-sm-10">
                                    <input :disabled="true" v-model="branch.couponById.couponCode" type="text" class="form-control">
                                  </div>
                                  <div class="col-lg-2">
                                    <a class="my_tip_update_coupon" title="Update Coupon" v-on:click="couponAlreadyApplied = false"><b class="fa fa-pencil fa-lg"></b></a> |
                                    <a class="my_tip_delete_coupon" title="Delete Coupon" v-on:click="deleteBranchCoupon()"><b class="fa fa-trash fa-lg"></b></a>
                                  </div>
                                </div>
                            </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="checkbox" v-if="branch.couponById !== null">
                                <label>
                                  <input type="checkbox" v-model="branch.applyOnDvm"> Apply on DVM
                                </label>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="checkbox" v-if="branch.couponById !== null">
                                <label>
                                  <input type="checkbox" v-model="branch.applyOnBayked"> Apply on Bebambi
                                </label>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div class="form-group">
                            <label>Menu Pictures</label>
                            <input :disabled="readOnly || isBranchUser" type="file" class="form-control menuPics" multiple="multiple" placeholder="Menu Pictures">
                        </div>

                        <div class="form-group">
                            <label>Vendor Pictures</label>
                            <input :disabled="readOnly || isBranchUser" type="file" class="form-control branchPics" multiple="multiple" placeholder="Branch Pictures">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button :disabled="readOnly" type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button :disabled="readOnly" type="submit" class="btn btn-primary">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import CitiesAndAreas from "@/components/utils/CitiesAndAreas"
    import moment from "moment";
    import Multiselect from 'vue-multiselect'
    import TimingsComponent from "../utils/TimingsComponent";
    import BranchMenuComponent from "../utils/BranchMenuComponent";
    import CostBasedConfiguration from "@/components/utils/CostBasedConfiguration.vue";
    import store from "@/store";

    export default {
        name: "AddUpdateBranch",
      computed: {
        store() {
          return store
        },
        isBranchUser(){
          return this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
        }
      },
        components: {
          CostBasedConfiguration,
          BranchMenuComponent,
          TimingsComponent,
          CitiesAndAreas,
          Multiselect
        },
        data() {
            return {
                branch: {
                    "id": 0,
                    "phone1": "",
                    "contactName1" : "",
                    "phone2": "",
                    "contactName2" : "",
                    "phone3": "",
                    "contactName3" : "",
                    "deliveryRadius": 0,
                    "masterBranch": false,
                    "minimumOrder": 0,
                    "deliveryConfigurations": '',
                    "costBasedDeliveryConfig": '',
                    "freeDelivery": false,
                    "deliveryEnabled":false,
                    "pickupEnabled":false,
                    "tax": 16,
                    "cardTax": 5,
                    "timings": [],
                    "disableTimingsForPortal": false,
                    "restaurantsByRestaurantId": {
                        "id": 0,
                    },
                    "areasByAreaId": {
                        "id": 0,
                        "citiesByCityId": {
                            "id": 0,
                        }
                    },
                    "couponById": null,
                    "open24Hours": false,
                    "isPortalEnabled": false,
                    "isEnable": true,
                    "applyOnDvm": true,
                    "applyOnBayked": true,
                    "socialMediaLinks" : null,
                },
                resName: "",
                resId: "",
                startTime:new Array(7).fill(null),
                endTime:new Array(7).fill(null),
                days:["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
                readOnly:false,
                userRole:'',
                couponAlreadyApplied: false,
                resCoupon: [],
                mediaLinks: {
                  "facebook": null,
                  "instagram": null,
                  "twitter": null,
                  "youtube": null,
                }
            }
        },
        mounted: async function () {
          let self = this;
          let addUpdateBranchModalObject = $('#add_update_branch_modal');
          addUpdateBranchModalObject.on('hidden.bs.modal', (e) => {
            if (this.$parent.selectedRow && this.$parent.selectedRow[this.resId] !== undefined && this.$parent.selectedRow[this.resId] !== null) {
              this.$parent.loadBranchesOfRestaurant(this.$parent.selectedRow[this.resId]);
            }
            if(this.$route.query.res === undefined && this.$route.query.br === undefined)
              this.resetData();
          });
          if (this.$route.query.res !== undefined && this.$route.query.br !== undefined && this.$route.query.coupId !== undefined) {
            let params = new URLSearchParams();
            params.append("restaurant_id", this.$route.query.res)
            let restaurantResp = await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_by_id", params);
            await this.load(this.$route.query.br, this.$route.query.res, restaurantResp.data.name);
          }
          $.fn.modal.Constructor.prototype.enforceFocus = function () {};
        },
        methods: {
            load: async function (branchId, restaurantId, restaurantName) {
              this.resName = restaurantName;
              this.resId = restaurantId;
              this.userRole = this.$store.state.user.userRolesById[0].role.split('_')[1]
              if (this.userRole === 'AGENT') {
                this.readOnly = true;
              }
              if (branchId > 0) {
                let params = new URLSearchParams();
                params.append("branch_id", branchId);
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_branch_by_id", params).then(resp => {
                  this.branch = resp.data;
                  if(this.branch.couponById !== null) {
                    this.couponAlreadyApplied = true;
                  }
                  this.branch.timings = resp.data.timings === null ? [] : JSON.parse(resp.data.timings);
                  // this.addBranchTimings();
                  if(this.branch.socialMediaLinks !== null) {
                    this.mediaLinks = JSON.parse(this.branch.socialMediaLinks);
                  }
                  this.$refs.cityAndAreaComp.selectedCity = this.branch.areasByAreaId.citiesByCityId.id;
                  this.$refs.cityAndAreaComp.selectedArea = this.branch.areasByAreaId.id;
                  this.$refs.cityAndAreaComp.getAreasOfCity();
                });
                let parameter = new URLSearchParams();
                parameter.append("restaurant_id", this.resId);
                await this.$http.get(this.$store.state.mainAppURL + "restaurants/get_restaurant_coupons", {
                  params: parameter
                }).then(resp => {
                  this.resCoupon = resp.data;
                })
                if(this.$route.query.coupId !== undefined){
                  let params1= new URLSearchParams();
                  params1.append("couponId", this.$route.query.coupId)
                  let CouponResp= await this.$http.get(this.$store.state.mainAppURL + "restaurants/get_coupon_by_coupon_id", {
                    params: params1
                  });
                  this.branch.couponById= CouponResp.data;
                  this.couponAlreadyApplied = false;
                }
              } else {
                this.branch.restaurantsByRestaurantId.id = restaurantId;
              }
              setTimeout(() => {
                $("#add_update_branch_modal").modal("show");
                $("#add_update_branch_modal").focus();
              }, 500);
            },
            resetFlags: function (){
              this.branch.applyOnDvm=true;
              this.branch.applyOnBayked=true;
            },
            addAddNewCoupon: function () {
              $("#add_update_branch_modal").modal("hide");
              this.$router.replace("/coupons?res="+this.resId+"&br="+this.branch.id);
            },
            deleteBranchCoupon: function () {
              Swal({
                title: 'Are you sure?',
                text: "Are you sure you want to delete this coupon!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
              }).then((result) => {
                if(result.value === true){
                  this.showLoading()
                  this.couponAlreadyApplied = false;
                  this.$http.delete(this.$store.state.mainAppURL + "restaurants/delete_coupon_by_branch_id/"+ this.branch.id).then(async resp => {
                    await this.load(this.branch.id, this.resId, this.resName)
                    swal("SUCCESS!", "Coupon has been deleted successfully!", "success");
                  }).catch(ex =>{
                    this.showErrorMessage(ex)
                  })
                }
                else {
                  swal("Error!", "Please try again!", "error");
                }
              });
            },
            addDeliveryConfig: function (index) {
                let self = this;
                swal({
                    title: 'Enter Configuration',
                    showCancelButton: true,
                    confirmButtonText: 'Save',
                    html:
                        '<input id="swal-input1" type="number" placeholder="From (KM)" class="form-control" min="0"><br/>' +
                        '<input id="swal-input2" type="number" placeholder="To (KM)" class="form-control" min="0"><br/>' +
                        '<input id="swal-input3" type="number" placeholder="Cost (Rs.)" class="form-control" min="0">',
                    preConfirm: function () {
                        return new Promise(function (resolve) {
                            resolve({
                                from_km: parseInt($('#swal-input1').val()),
                                to_km:  parseInt($('#swal-input2').val()),
                                cost: parseInt($('#swal-input3').val())
                            })
                        })
                    },
                    onOpen: function () {
                        $('#swal-input1').focus();
                        if (index || index === 0) {
                          $('#swal-input1').val(self.branch.deliveryConfigurations[index].from_km);
                          $('#swal-input2').val(self.branch.deliveryConfigurations[index].to_km);
                          $('#swal-input3').val(self.branch.deliveryConfigurations[index].cost);
                        }
                    }
                }).then(function (result) {
                    if(result.dismiss === "overlay" || result.dismiss === "cancel") {
                        return false;
                    }
                    if(result.value !== undefined) {
                      if (index || index === 0) {
                        self.branch.deliveryConfigurations[index].from_km = parseInt($('#swal-input1').val())
                        self.branch.deliveryConfigurations[index].to_km = parseInt($('#swal-input2').val())
                        self.branch.deliveryConfigurations[index].cost = parseInt($('#swal-input3').val())
                      } else {
                        self.branch.deliveryConfigurations.push(result.value);
                      }
                    }
                }).catch(swal.noop)
            },
            deleteConfig: function (index) {
                this.branch.deliveryConfigurations.splice(index, 1);
            },
            resetData: function () {
                Object.assign(this.$data, this.$options.data.call());
                this.$refs.cityAndAreaComp.resetData();
            },
            validateConfig(arr) {
              return arr.some(obj => Object.values(obj).some(val => val < 0));
            },
            addUpdateBranch: function () {
                let menuPicsSelector = $(".menuPics");
                let branchPicSelector = $(".branchPics");
                let timings  = this.$refs.TimingsConfiguration.updateBranchTimings();
                if(timings.length === 0){
                  return;
                }
                this.branch.timings = timings;
                this.branch.areasByAreaId.id = this.$refs.cityAndAreaComp.selectedArea;
                this.branch.areasByAreaId.citiesByCityId.id = this.$refs.cityAndAreaComp.selectedCity;

                if (this.$refs.distanceBasedDeliveryConfiguration.distanceBased && this.validateConfig(this.$refs.distanceBasedDeliveryConfiguration.distanceBased)){
                  swal("Error!","Delivery configuration must be positive!", "error");
                  return;
                }
                if (this.validateConfig(this.$refs.costBasedDeliveryConfiguration.costBased)){
                  swal("Error!","Delivery configuration must be positive!", "error");
                  return;
                }
                this.branch.deliveryConfigurations = JSON.stringify(this.$refs.distanceBasedDeliveryConfiguration.distanceBased);
                this.branch.costBasedDeliveryConfig = JSON.stringify(this.$refs.costBasedDeliveryConfiguration.costBased)
                this.branch.socialMediaLinks = JSON.stringify(this.mediaLinks);
                this.branch.timings = JSON.stringify(this.branch.timings);
                let formData = new FormData();
                console.log(menuPicsSelector.prop('files'));
                console.log( branchPicSelector.prop('files'));
                for( let i = 0; i < menuPicsSelector.prop('files').length; i++ ){
                    let file = menuPicsSelector.prop('files')[i];
                    console.log(file);
                    formData.append('menuPics', file);
                }
                console.log("****");
                for( let i = 0; i < branchPicSelector.prop('files').length; i++ ){
                    let file = branchPicSelector.prop('files')[i];
                    console.log(file);
                    formData.append('branchPics', file);
                }
                formData.append('branch', JSON.stringify(this.branch));
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                this.$http.post(this.$store.state.mainAppURL + "restaurants/add_update_branch",
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data;'
                        }
                    }).then(resp => {
                        if(resp.data){
                            menuPicsSelector.val("");
                            branchPicSelector.val("");
                            $("#add_update_branch_modal").modal("hide");
                            Swal.close();
                            if(this.$route.query.br !== undefined && this.$route.query.res !== undefined)
                              this.$router.replace("/restaurants");
                        }else if(!resp.data){
                            swal("Error!","Cannot Set Two Master Branches, Kindly Remove Previous Master Branch And Try Again", "error");
                        }else{
                            swal("Error!","Please try again!", "error");
                        }
                }).catch(ex => {
                  this.showErrorMessage(ex)
                  this.load(this.branch.id, this.resId, this.resName)
                });
            }
        }
    }
</script>

<style>
    .clockpicker-popover {
        z-index: 999999;
    }
    .center {
      display: flex;
      justify-content: center;
      align-items: baseline;
    }
</style>
